/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Save_Set_LogInputs */

const en_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error saving set:`)
};

const fr_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'enregistrement de l'ensemble :`)
};

const de_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern des Satzes:`)
};

const it_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante il salvataggio del set:`)
};

const ru_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка сохранения набора:`)
};

const es_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al guardar el conjunto:`)
};

const zh_cn2_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存数据集时出错：`)
};

const ja_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットの保存中にエラーが発生しました:`)
};

const hi_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट सहेजने में त्रुटि:`)
};

const pt_pt2_tags_manager_error_save_set_log = /** @type {(inputs: Tags_Manager_Error_Save_Set_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao salvar o conjunto:`)
};

/**
* | output |
* | --- |
* | "Error saving set:" |
*
* @param {Tags_Manager_Error_Save_Set_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_save_set_log = /** @type {((inputs?: Tags_Manager_Error_Save_Set_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Save_Set_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_error_save_set_log(inputs)
	if (locale === "de") return de_tags_manager_error_save_set_log(inputs)
	if (locale === "it") return it_tags_manager_error_save_set_log(inputs)
	if (locale === "ru") return ru_tags_manager_error_save_set_log(inputs)
	if (locale === "es") return es_tags_manager_error_save_set_log(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_error_save_set_log(inputs)
	if (locale === "ja") return ja_tags_manager_error_save_set_log(inputs)
	if (locale === "hi") return hi_tags_manager_error_save_set_log(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_error_save_set_log(inputs)
	return en_tags_manager_error_save_set_log(inputs)
});